import { html } from "lit-element";
import { StofwareElement } from "@stofloos/core/base/sw-element";
import "@stofloos/components/atoms/user/user-circle-image";
import { style } from "./style";
import { store } from "@stofloos/stores/store";
import { connect } from "pwa-helpers";
import { LayoutFlex } from "@stofloos/globals/styles/layout-flex";

class UserLabel extends connect(store)(StofwareElement) {
	static get styles() {
		return [LayoutFlex, style];
	}

	static get properties() {
		return {
			_profile: Object
		};
	}

	render() {
		return html`
			<a ?selected="${this._page === "profiel"}" href="/userprofile/details/${this._profile.id}?collapsed" class="layout horizontal right">
				<user-circle-image
					image="${this._profile.profile_image_url}"
					first-name="${this._profile.first_name}}"
					surname="${this._profile.surname}"
				></user-circle-image>
				<span class="user-menu-button user-label-name"
					>${this._profile.first_name} ${this._profile.surname}</span
				>
			</a>
		`;
	}

	shouldUpdate() {
		return !!this._profile;
	}

	stateChanged(state) {
		this._profile = state.StofwareProfile.profile;
	}
}

window.customElements.define("user-label", UserLabel);
